// src/admin/components/Chip.tsx
// Pill-shaped label used for status, tier, category. The earlier StatusChip is
// kept for backward compat; new code should reach for this Chip and pick a tone
// directly instead of relying on label-driven colour.
import type { ReactNode } from 'react';
import styles from './Chip.module.css';

export type ChipTone =
  | 'neutral' | 'brand' | 'success' | 'warning' | 'danger' | 'info' | 'violet';
export type ChipSize = 'sm' | 'md' | 'lg';

interface Props {
  tone?: ChipTone;
  size?: ChipSize;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function Chip({ tone = 'neutral', size = 'md', icon, children, className }: Props) {
  const cls = [styles.chip, styles[tone], size !== 'md' && styles[size], className]
    .filter(Boolean).join(' ');
  return (
    <span className={cls}>
      {icon}
      {children}
    </span>
  );
}
